/**
 * Parse thread inventory from CSV
 * Returns a Map of threadNumber -> quantity
 */

export function parseThreadInventory() {
  // Your current inventory data
  const inventoryData = {
    // Column 1
    '1727': 0, '1623': 8, '1924': 17, '1866': 0, '1735': 8, '1724': 0, '1561': 0, '1666': 0,
    '1661': 0, '1622': 0, '1861': 0, '1683': 0, '1980': 0, '1971': 18, '1624': 19, '1772': 8,
    '1771': 0, '1625': 4, '1725': 0, '1869': 10, '1763': 8, '1626': 0, '1951': 13, '1955': 4,
    '1825': 8,
    // Column 2
    '1826': 0, '1923': 0, '1755': 0, '1965': 4, '1765': 14, '1621': 4, '1521': 8, '1853': 0,
    '1882': 0, '1752': 0, '1778': 0, '1678': 10, '1987': 23, '1878': 18, '1588': 8, '1637': 0,
    '1838': 8, '1839': 8, '1747': 8, '1653': 0, '1817': 0, '1820': 0, '1952': 8, '1821': 0,
    '1899': 4,
    // Column 3
    '1734': 4, '1754': 0, '1819': 0, '1777': 0, '1779': 0, '1982': 8, '1638': 10, '1974': 4,
    '1639': 0, '1616': 0, '1915': 8, '1620': 0, '1707': 0, '1781': 13, '1981': 0, '1784': 10,
    '1567': 0, '1919': 0, '1917': 4, '1713': 0, '1818': 0, '1941': 0, '1998': 0, '1887': 0,
    '1983': 0,
    // Column 4
    '1508': 16, '1509': 0, '1986': 0, '1681': 0, '1994': 0, '1948': 0, '1816': 0, '1815': 0,
    '1786': 0, '1910': 0, '1993': 0, '1909': 0, '1548': 8, '1721': 0, '1584': 0, '1984': 4,
    '1549': 0, '1921': 0, '1990': 0, '1787': 0, '1783': 0, '1785': 0, '1835': 0, '1782': 0,
    '1635': 8,
    // Column 5
    '1709': 8, '1710': 8, '1788': 0, '1833': 8, '1633': 8, '1880': 0, '1631': 0, '1831': 0,
    '1712': 0, '1911': 0, '1834': 0, '1680': 0, '1719': 8, '1720': 0, '1789': 0, '1731': 0,
    '1711': 8, '1832': 8, '1922': 8, '1522': 4, '1634': 8, '1553': 4, '1630': 0, '1933': 0,
    '1722': 4,
    // Column 6
    '1629': 4, '1529': 0, '1627': 0, '1632': 0, '1997': 0, '1766': 0, '1930': 0, '1943': 0,
    '1767': 4, '1743': 0, '1966': 10, '1566': 16, '1830': 0, '1676': 8, '1642': 8, '1532': 0,
    '1842': 11, '1843': 8, '1967': 4, '1555': 4, '1844': 0, '1976': 0, '1944': 0, '1643': 8,
    '1574': 0,
    // Column 7
    '1874': 0, '1562': 8, '1542': 0, '1531': 8, '1975': 19, '1742': 4, '1934': 20, '1829': 18,
    '1733': 0, '1528': 0, '1675': 0, '1674': 0, '1953': 8, '1871': 13, '1828': 4, '1775': 0,
    '1776': 0, '1764': 11, '1671': 0, '1628': 0, '1550': 0, '1960': 8, '1961': 8, '1964': 0,
    '1963': 0,
    // Column 8
    '1563': 0, '1761': 0, '1760': 8, '1962': 8, '1932': 4, '1827': 18, '1593': 10, '1977': 9,
    '1797': 24, '1762': 8, '1852': 4, '1992': 0, '1893': 0, '1895': 0, '1695': 0, '1896': 0,
    '1577': 0, '1594': 0, '1694': 19, '1892': 4, '1888': 8, '1846': 0, '1890': 0, '1991': 0,
    '1891': 0,
    // Column 9
    '1645': 0, '1799': 0, '1685': 4, '1677': 0, '1746': 0, '1692': 0, '1592': 0, '1652': 8,
    '1690': 0, '1996': 0, '1704': 4, '1985': 0, '1879': 8, '1847': 4, '1868': 8, '1780': 0,
    '1849': 8, '1979': 0, '1647': 8, '1989': 0, '1751': 10, '1750': 0, '1845': 0, '1580': 8,
    '1703': 0,
    // Column 10
    '1770': 0, '1748': 0, '1848': 4, '1701': 23, '1650': 4, '1749': 0, '1988': 20, '1851': 12,
    '1651': 8, '1702': 4, '1900': 8, '1545': 0, '1578': 0, '1903': 0, '1902': 8, '1904': 8,
    '1970': 13, '1968': 10, '1648': 0, '1768': 0, '1541': 0, '1940': 8, '1649': 8, '1769': 8,
    '1905': 4,
    // Column 11
    '1668': 0, '1705': 0, '1669': 4, '1798': 0, '1969': 0, '1568': 8, '1569': 0, '1795': 0,
    '1794': 0, '1796': 0, '1956': 0, '1756': 4, '1790': 4, '1706': 0, '1552': 0, '1920': 0,
    '1792': 0, '1959': 8, '1809': 4, '1759': 0, '1793': 0, '1757': 0, '1684': 0, '1939': 0,
    '1906': 0,
    // Column 12
    '1660': 0, '1854': 0, '1654': 0, '1859': 0, '1931': 0, '1554': 0, '1942': 0, '1999': 0,
    '1836': 0, '1958': 0, '1656': 0, '1729': 0, '1945': 0, '1858': 8, '1658': 0, '1898': 0,
    '1856': 0, '1753': 0, '1857': 8, '1926': 0, '1657': 0, '1659': 0, '1558': 0, '1559': 0,
    '1560': 0,
    // Column 13
    '1557': 0, '1745': 0, '1929': 0, '1744': 8, '1936': 0, '1736': 0, '1938': 8, '1573': 0,
    '1872': 0, '1928': 0, '1728': 0, '1855': 0, '1884': 10, '1885': 0, '1527': 8, '1927': 4,
    '1556': 0, '1726': 8, '1949': 0, '1723': 8, '1870': 8, '1773': 4, '1973': 0, '1565': 0,
    '1758': 4,
    // Column 14
    '1739': 8, '1540': 8, '1741': 20, '1812': 9, '1810': 8, '1665': 0, '1664': 0, '1862': 0,
    '1860': 0, '1662': 0, '1663': 0, '1535': 0, '1738': 8, '1682': 4, '1582': 0, '1822': 0,
    '1863': 0, '1526': 8, '1670': 0, '1673': 0, '1672': 0, '1791': 8, '1538': 0, '1730': 8,
    '1957': 4,
    // Column 15
    '1617': 0, '1619': 0, '1618': 8, '1740': 0, '1886': 0, '1686': 0, '1687': 4, '1505': 18,
    '1572': 0, '1640': 0, '1614': 8, '1539': 18, '1689': 4, '1615': 4, '1502': 0, '1918': 18,
    '1718': 8, '1611': 0, '1612': 8, '1840': 0, '1841': 8, '1641': 0, '1544': 0, '1506': 0,
    '1507': 0,
    // Column 16
    '1575': 8, '1613': 8, '1610': 0, '1811': 0, '1564': 13, '1589': 0, '1500': 0, '1800': 0,
    '2800': 0, '1805': 0, '1801': 0, '1802': 0, '1804': 0, '1803': 0,
    // Fluorescent
    '1925': 0, '1972': 0, '1824': 0, '1883': 0, '1995': 0, '1823': 0, '1935': 8, '1867': 0,
    '1599': 8, '1850': 8, '1950': 0, '1901': 4,
    '1937': 0, '1978': 0, '1946': 8, '1598': 0, '1837': 0, '1947': 8, '1954': 0, '1908': 0,
    '1907': 0, '1597': 4, '1596': 0, '1595': 0,
    // Special threads (FS 30, Frosted Matt 40, Multicolor - not in main Polyneon list)
    // These won't be in the 412 Polyneon threads, so we skip them
  };

  return inventoryData;
}

// Helper to check if thread is in stock (quantity >= 2 based on user's requirement)
export function isThreadInStock(quantity) {
  return quantity && quantity >= 2;
}



